module.exports = __webpack_public_path__ + "static/media/Child.8d3574e5.svg";